import { atom } from 'jotai'

import * as s1 from './state.profile.access'
import { ERoleAccess } from '../types/enum'

// read-only derived atom
export const isRootAtom = atom(
	// getter
	(get) => {
		const access = get(s1.accessAtom)
		const rule = access.find((item) => item.$key === ERoleAccess.Any)
		return rule?.$value ?? false
	}
)